import { usePensionNameValue } from "@/shared/client";
import { useGetCommon, type AroundDmaxInfoResponse, type AttractionResponse } from "@/shared/server";
import { MEDIA } from "@/styles/common";
import { Box, Center, Flex, Spinner, Text } from "@chakra-ui/react";
import DOMPurify from "dompurify";

export const Attractions = ({ around }: { around?: AroundDmaxInfoResponse }) => {
    const { data } = useGetCommon<AttractionResponse>({ section: "travels" });
    const pensionName = usePensionNameValue();
    const { isMobile } = MEDIA();

    return around || data ? (
        <Center position="relative" as="section" zIndex="1">
            <Box
                position="absolute"
                maxW="1316px"
                w="100%"
                h={isMobile ? "196px" : "288px"}
                top={isMobile ? "none" : "50%"}
                bottom={isMobile ? "0" : "none"}
                left="0"
                transform={isMobile ? "none" : "translateY(-30%)"}
                background="#F8F8F8"
                zIndex="0"
            />
            <Flex
                maxW="1600px"
                w="100%"
                p={isMobile ? "0 16px" : "0 48px"}
                flexDir={isMobile ? "column-reverse" : "row"}
                columnGap={isMobile ? "0" : "48px"}
                rowGap={isMobile ? "16px" : "0"}
                zIndex="1"
            >
                <Flex maxW="728px" w="100%" flexDir="column" rowGap={isMobile ? "0" : "48px"}>
                    <Box
                        display={isMobile ? "none" : "block"}
                        maxW="628px"
                        w="100%"
                        h="464px"
                        background={
                            around?.imgList[0]
                                ? `url(${around.imgList[0].img_URL})no-repeat center/cover`
                                : `url(${data?.imgList[0].imgUrl})no-repeat center/cover`
                        }
                    ></Box>
                    <Box
                        sx={{
                            "& p": {
                                fontFamily: "Cormorant",
                                lineHeight: "120%",
                                fontSize: isMobile ? "12px" : "20px",
                                fontWeight: "700",
                                color: "#dcdcdc",
                            },
                        }}
                    >
                        <Text>{`Don't wait up. Don't be shy about liking and loving someone.`}</Text>
                        <Text>Rather than living with an empty heart, love someone full of heart</Text>
                    </Box>
                </Flex>
                <Flex w="100%" flexDir="column" rowGap="24px">
                    <Flex
                        flexDir="column"
                        h={isMobile ? "auto" : "264px"}
                        w="100%"
                        rowGap="16px"
                        sx={{
                            "& p": {
                                fontFamily: "Noto Serif KR",
                                fontWeight: "400",
                                lineHeight: "140%",
                                color: "#6b6b6b",
                            },
                        }}
                    >
                        <Flex flexDir="column" rowGap="8px">
                            <Text fontSize={isMobile ? "20px" : "24px"}>다양한 주변관광지와 함께하는 휴식</Text>
                            <Text fontSize={isMobile ? "20px" : "40px"} fontWeight="600" color="#333 !important">
                                AROUND PENSION
                            </Text>
                        </Flex>
                        <Box
                            sx={{
                                "& p": {
                                    fontFamily: "Pretendard",
                                    fontWeight: "300",
                                    lineHeight: "140%",
                                    fontSize: isMobile ? "14px" : "16px",
                                },
                            }}
                        >
                            {around?.intro ? (
                                <Text
                                    dangerouslySetInnerHTML={{
                                        __html: DOMPurify.sanitize(around.intro.replace(/\r?\n/g, "<br />")),
                                    }}
                                />
                            ) : (
                                <>
                                    <Text>다양한 즐길거리와 볼거리가 가득한 {pensionName.kor}에서</Text>
                                    <Text>사랑하는 가족, 연인, 친구들과 평생</Text>
                                    <Text>잊지못할 추억을 만들어 보세요.</Text>
                                </>
                            )}
                        </Box>
                    </Flex>
                    <Flex
                        flexDir={isMobile ? "column" : "row"}
                        alignItems={isMobile ? "normal" : "flex-end"}
                        columnGap="24px"
                        rowGap={isMobile ? "16px" : "0"}
                    >
                        <Box
                            maxW={isMobile ? "none" : "400px"}
                            w="100%"
                            h={isMobile ? "256px" : "504px"}
                            background={
                                around?.imgList[1]
                                    ? `url(${around.imgList[1].img_URL})no-repeat center/cover`
                                    : `url(${data?.imgList[1].imgUrl})no-repeat center/cover`
                            }
                        />
                        <Box
                            maxW={isMobile ? "none" : "304px"}
                            w="100%"
                            h={isMobile ? "256px" : "288px"}
                            background={
                                around?.imgList[2]
                                    ? `url(${around.imgList[2].img_URL})no-repeat center/cover`
                                    : `url(${data?.imgList[2].imgUrl})no-repeat center/cover`
                            }
                        />
                    </Flex>
                </Flex>
            </Flex>
        </Center>
    ) : (
        <Spinner />
    );
};
